/* eslint-env jest */
import buildOrderPayload from './orderPayload';

const intentData = {
  metadata: { cart_id: '5659770', cart_email: 'parent@example.com' },
  payment_method: {
    billing_details: {
      address: {
        line1: '1 Main St', city: 'Modesto', state: 'CA', postal_code: '95356',
      },
    },
  },
};
const stored = JSON.stringify({
  firstName: 'Pat',
  lastName: 'Parent',
  phone: '2095551234',
  shippingAddress: {
    address1: '2 Oak Ave', city: 'Modesto', state: 'CA', zip: '95356',
  },
});

describe('buildOrderPayload', () => {
  it('uses sessionStorage contact details when the stored cart matches the paid cart', () => {
    const p = buildOrderPayload({
      intentData, paymentIntentId: 'pi_1', storedCartId: '5659770', storedEmail: 'x@y.z', storedCustomerDataJson: stored,
    });
    expect(p).toMatchObject({
      cart_id: '5659770', email: 'parent@example.com', phone: '2095551234', shipping_address: '2 Oak Ave', address: '1 Main St',
    });
  });

  it('still creates the order (blank contact) when sessionStorage holds a DIFFERENT cart', () => {
    const p = buildOrderPayload({
      intentData, paymentIntentId: 'pi_1', storedCartId: '5555331', storedEmail: 'stale@x.z', storedCustomerDataJson: stored,
    });
    // Identity from the intent -- the stale cart's details are ignored, not replayed.
    expect(p.cart_id).toBe('5659770');
    expect(p.email).toBe('parent@example.com');
    expect(p.phone).toBe('');
    expect(p.shipping_address).toBe('');
    expect(p.address).toBe('1 Main St'); // billing still comes from the payment method
  });

  it('returns null when the intent carries no cart identity (caller must fail loudly)', () => {
    expect(buildOrderPayload({
      intentData: {}, paymentIntentId: 'pi_1', storedCartId: '5659770', storedEmail: null, storedCustomerDataJson: stored,
    })).toBeNull();
  });

  it('never borrows a mismatched session email when the intent has none (fails to null)', () => {
    const noEmail = { ...intentData, metadata: { cart_id: '5659770', cart_email: '' } };
    expect(buildOrderPayload({
      intentData: noEmail,
      paymentIntentId: 'pi_1',
      storedCartId: '5555331',
      storedEmail: 'stranger@x.z',
      storedCustomerDataJson: stored,
    })).toBeNull();
    // ...but a MATCHING session may stand in for a blank cart_email.
    const p = buildOrderPayload({
      intentData: noEmail,
      paymentIntentId: 'pi_1',
      storedCartId: '5659770',
      storedEmail: 'parent@example.com',
      storedCustomerDataJson: stored,
    });
    expect(p.email).toBe('parent@example.com');
  });

  it('survives corrupt stored JSON', () => {
    const p = buildOrderPayload({
      intentData, paymentIntentId: 'pi_1', storedCartId: '5659770', storedEmail: null, storedCustomerDataJson: '{nope',
    });
    expect(p.first_name).toBe('');
    expect(p.cart_id).toBe('5659770');
  });
});
